module.exports = __webpack_public_path__ + "img/blue.561c962.svg";